import { useTranslation } from 'react-i18next';
import "../../CSS/ExternalVideo.css";
import { useUserContext } from '../../../hooks/useUserContext';
import CustomQuiz from '../../games/CustomQuiz/CustomQuiz';
import { quiz_de } from './angemessene_therapie/quiz_de';
import { quiz_fr } from './angemessene_therapie/quiz_fr';
import { quiz_it } from './angemessene_therapie/quiz_it';

export default function AngemesseneTherapie({ oldAndNewScore }) {
    const { t } = useTranslation();

    const { games, updateGames, calculateScore, score } = useUserContext();
    const quiz_game = games.angemessene_therapie;

    const { i18n } = useTranslation();
    let quiz = '';
    switch(i18n.language) {
        case 'de':
            quiz = quiz_de;
            break;
        case 'fr':
            quiz = quiz_fr;
            break;
        case 'it':
            quiz = quiz_it;
            break;
        default:
            quiz = quiz_de;
    };

    const setQuizResult = (achieved_points) => {
        //console.log(obj.correctPoints);
        const angemessene_therapie = { ...quiz_game, state: 'done', points_achieved: achieved_points };
        const games_new = { ...games, angemessene_therapie: angemessene_therapie };
        updateGames(games_new);
        const current_game = "angemessene_therapie";
        let total_score = calculateScore(current_game);
        total_score += achieved_points;
        const oldScore = score;
        const newScore = total_score;
        oldAndNewScore(oldScore, newScore);
    };

    return (
        <>
            <div>
                <CustomQuiz inputQuiz={quiz} finishFunction={setQuizResult}/>
            </div>
        </>
    )
}
